import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["p", "br", "b", "strong", "i", "em", "u", "s", "h2", "h3", "h4", "ul", "ol", "li", "a", "blockquote", "span", "div"];
const ALLOWED_ATTR = ["href", "target", "rel", "style", "class"];

export function RichText({ html, className = "", testid }) {
  if (!html) return null;
  const hasTags = /<[a-z][\s\S]*>/i.test(html);
  if (!hasTags) {
    // Plain text (e.g. legacy descriptions) — preserve line breaks.
    return <p data-testid={testid} className={`rich-text whitespace-pre-line ${className}`}>{html}</p>;
  }
  const clean = DOMPurify.sanitize(html, { ALLOWED_TAGS, ALLOWED_ATTR });
  return (
    <div
      data-testid={testid}
      className={`rich-text ${className}`}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
